<ts-dialog title="Add Project" (closeDialog)="discard()">
  <main ts-dialog-body class="flex flex-col flex-1 w-full">
    <form [formGroup]="projectForm">
      <section class="flex flex-col flex-1">
        <mat-form-field class="flex-auto">
          <mat-label>Project Name</mat-label>
          <input
            matInput
            [formControlName]="'title'"
            [placeholder]="'Project Name'"
            [spellcheck]="false"
            [readonly]="isOptionsLoading"
          />
          @if (projectForm.get('title').hasError('required') && projectForm.get('title').touched) {
            <mat-hint>Project name is required.</mat-hint>
          }
        </mat-form-field>

        <div class="flex flex-col gt-xs:flex-row">
          <mat-form-field class="flex-auto gt-xs:pr-3">
            <mat-label>View</mat-label>
            <mat-select [formControlName]="'pipeline_id'" [disabled]="isOptionsLoading">
              @for (pipeline of pipelines; track pipeline.id) {
                <mat-option [value]="pipeline.id">{{ pipeline.name }}</mat-option>
              }
            </mat-select>
          </mat-form-field>

          <mat-form-field class="flex-auto">
            <mat-label>Template</mat-label>
            <mat-select [formControlName]="'template_id'" [disabled]="isOptionsLoading">
              @for (template of projectTemplates; track template.id) {
                <mat-option [value]="template.id">{{ template.name }}</mat-option>
              }
            </mat-select>
            @if (projectForm.get('template_id').hasError('required') && projectForm.get('template_id').touched) {
              <mat-hint>Template is required.</mat-hint>
            }
          </mat-form-field>
        </div>

        <div class="flex flex-col gt-xs:flex-row">
          <fieldset class="w-full" [formGroupName]="'property'">
            <fieldset class="w-full" [formGroupName]="'address'">
              <mat-form-field class="flex-auto w-full">
                <mat-label>Address</mat-label>
                <input
                  matInput
                  google-place
                  [placeholder]="'Address'"
                  [formControlName]="'address_string'"
                  (onSelect)="setAddress($event)"
                  (onSelectParts)="setAddressParts($event)"
                  autocomplete="none"
                  [disabled]="isOptionsLoading"
                />
              </mat-form-field>
            </fieldset>
          </fieldset>
        </div>
      </section>
    </form>
  </main>

  <footer ts-dialog-actions class="ts-dialog-actions-container">
    <ts-button variant="secondary" (click)="discard()">Cancel</ts-button>
    <ts-button variant="primary" [disabled]="isSaveBtnDisabled" (click)="saveProject()">
      @if (!isLoading) {
        Create and Save
      } @else {
        Saving...
      }
    </ts-button>
  </footer>
</ts-dialog>
